export default __webpack_public_path__ + "static/news-details-4df38837d96ad61b5d0f5798e7dedc83.png";